export default __webpack_public_path__ + "static/media/challenge-end.687a50d3.wav";